import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	zenModeSelector: {
		id: 'app.components.SceneFadeControl.BackgroundFade',
		defaultMessage: 'Show scene when idle',
		description: 'A title for a checkbox to control the scene fade on idle',
	},
});
